module.exports = __webpack_public_path__ + "static/media/fluencyeb614e42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/fluency.svg
// module id = 1329
// module chunks = 0